import React from "react";
import styled from "styled-components";
import IconSubstack from "../svg/IconSubstack";
import IconFacebook from "../svg/IconFacebook";
import IconInstagram from "../svg/IconInstagram";
import IconYouTube from "../svg/IconYouTube";
import IconApplePodcasts from "../svg/IconApplePodcasts";
import IconTwitter from "../svg/IconTwitter";
import dataNav from "../../data/nav.json";
import { Link } from "gatsby";
import Button from "../Button";
import { ArrowUpRight } from "../Arrow";


const Footer = () => {
  const navsWithLinks = dataNav.filter( item => item.links && item.links.length > 0);
  return (
    <StyledFooter>
      <nav>
        {navsWithLinks.map((nav, index) => (
          <div key={`footer-nav-${nav.slug}`}>
            <h3>{nav.label}</h3>
            <ul>
              {nav.links.map((link, index) => (
                <li key={index}>
                  {link.url ? (
                    <a href={link.url} title={link.prelabel || link.label}>{link.prelabel || link.label}</a>
                  ) : (
                    <Link to={`/${link.slug}`} title={link.prelabel || link.label}>{link.prelabel || link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
      <aside>
        <Button as="a" href="https://theoutlawocean.substack.com/" target="_blank" rel="noopener noreferrer">Subscribe <span className="arrow"><ArrowUpRight /></span></Button>
      </aside>
      <div className="social">
        <a href="mailto:media@theoutlawocean.com" title="Email The Outlaw Ocean Project">media@theoutlawocean.com</a>
        <aside>
          <a href="https://theoutlawocean.substack.com/" target="_blank" rel="noopener noreferrer"><IconSubstack /></a>
          <a href="https://podcasts.apple.com/us/podcast/the-outlaw-ocean/id1641743797" target="_blank" rel="noopener noreferrer"><IconApplePodcasts /></a>
          <a href="https://www.youtube.com/c/theoutlawoceanproject" target="_blank" rel="noopener noreferrer"><IconYouTube /></a>
          <a href="https://www.instagram.com/ian_urbina/" target="_blank" rel="noopener noreferrer"><IconInstagram /></a>
          <a href="https://www.facebook.com/IanUrbinaReporter/" target="_blank" rel="noopener noreferrer"><IconFacebook /></a>
          <a href="https://twitter.com/ian_urbina/" target="_blank" rel="noopener noreferrer"><IconTwitter /></a>
        </aside>
      </div>
    </StyledFooter>
  );
};

export default Footer;

const StyledFooter = styled.footer`
  position: relative;
  padding: 3em var(--gutter) 2em;
  max-width: var(--max-width);
  margin: 0 auto;
  display: grid;
  gap: 3em;
  z-index: 0;
  &::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    border-top: 1px solid rgba(255,255,255,0.2);
    background-color: var(--color-black);
  }
  @media ( min-width: 48em ) {
    grid-template: auto / 3fr 1fr;
    .social {
      grid-column: 1 / span 2;
    }
    > aside {
      place-self: center;
    }
  }
  nav {
    display: flex;
    gap: 3em;
    @media ( max-width: 48em ) {
      display: grid;
      grid-template: auto / 1fr 1fr;
      gap: 1.5em 3em;
    }

    h3 {
      font-size: 0.75em;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      margin-bottom: 1em;
      opacity: 0.6;
    }
    ul {
      display: flex;
      flex-direction: column;
      gap: 0.5em;
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        font-size: 0.9375em;
        a {
          .can-hover &:hover,
          &:active {
            text-decoration-line: underline;
            text-decoration-thickness: 0.75px;
            text-underline-offset: 0.1em;
            opacity: 1;
          }
        }
        .can-hover & a:hover,
        &:active a {
          opacity: 1;
        }
      }
    
    }
  }
  .social {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(255,255,255,0.2);
    padding-top: 1.5em;

    @media ( max-width: 48em ) {
      flex-direction: column;
      align-items: center;
      padding: 3em var(--gutter) 2em;
      gap: 1.5em;
    }
    a {
      opacity: 0.5;
      transition: opacity 0.2s ease;
    }
    .can-hover & a:hover,
    &:active a {
      opacity: 1;
    }
    > a {
      font-size: 0.75em;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }
    aside {
      display: flex;
      gap: 1.5em;
      align-items: center;
      a {
        display: grid;
        position: relative;
        height: 1.125em;
        width: 1.125em;
        &:first-of-type {
          height: 1em;
        }
        svg {
          width: 100%;
          height: 100%;
          path {
            fill: currentColor;
          }
        }
      }
    }
  }
  
`;